import { MarkovTransition } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovTransitionList = (transitionList: types.MarkovTransitionList) => ({
    type: inferLiteral(types.MARKOV_TRANSITION_LIST),
    transitionList,
})
export const setMarkovTransitionIds = (transitionIds: readonly number[]) => ({
    type: inferLiteral(types.MARKOV_TRANSITION_IDS),
    transitionIds,
})
export const setMarkovTransitionEdit = (transition: MarkovTransition) => ({
    type: inferLiteral(types.MARKOV_TRANSITION_EDIT),
    transition,
})
export const setMarkovTransitionCalculatedExpressions = (calcualted: types.MarkovTransitionCalculated) => ({
    type: inferLiteral(types.MARKOV_TRANSITION_CALCULATED_EXPRESSIONS),
    calcualted,
})
export const setMarkovTransitionSort = (sortColumn: keyof MarkovTransition, sortOrder: OrderType) => ({
    type: inferLiteral(types.MARKOV_TRANSITION_SORT),
    sortColumn,
    sortOrder,
})
export const setMarkovTransitionReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_TRANSITION_RELOAD_LIST),
    value,
})
export const setMarkovTransitionReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_TRANSITION_RELOAD_EDIT),
    value,
})
